module.exports = __webpack_public_path__ + "images/homepage-support-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./_common/images/homepage-support-icon.svg
// module id = 157
// module chunks = 1